module.exports = __webpack_public_path__ + "img/itx-file-type-pdf.5c9de1ec.svg";